import React, { memo} from 'react'
import DocumentContainer from './DocumentContainer'
import { Spinner } from 'react-bootstrap'

const DocumentContainers = memo(({ documentContainers, loadingStates}) => {
  if (loadingStates.getDocumentContainers) {
    return <div className="d-flex align-items-center justify-content-center"><Spinner animation='border' variant='primary' /></div>
  }
  return (
    <>
      {documentContainers.map((documentContainer, index) => (
        <DocumentContainer
          key={documentContainer.id}
          documentContainer={documentContainer}
        />
      ))}
    </>
  )
})
export default DocumentContainers